module.exports = __webpack_public_path__ + "img/bcard_0.77d47163.png";